import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { InternationalizationProvider } from '@astryxdesign/core/i18n';
import ruRU from '@astryxdesign/core/locales/ru-RU.generated.js';
import { queryClient } from './queryClient';
import { router } from './router';

export function App() {
  return (
    <InternationalizationProvider locale="ru-RU" messages={{ 'ru-RU': ruRU }}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </InternationalizationProvider>
  );
}
